import { Button, DatePicker, Flex } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import {
  PERIOD_PRESETS,
  matchingPreset,
  presetPeriod,
  tenantToday,
  type HistoryPeriod,
} from './historyPeriod'

const ISO_DAY = 'YYYY-MM-DD'

interface HistoryPeriodPickerProps {
  period: HistoryPeriod
  onChange: (period: HistoryPeriod) => void
}

export function HistoryPeriodPicker({ period, onChange }: HistoryPeriodPickerProps) {
  const { t } = useTranslation()
  const today = tenantToday()
  const active = matchingPreset(period, today)

  return (
    <Flex vertical gap={10}>
      <Flex gap={6} wrap>
        {PERIOD_PRESETS.map((preset) => (
          <Button
            key={preset}
            type={active === preset ? 'primary' : 'default'}
            onClick={() => onChange(presetPeriod(preset, today))}
            style={{ flex: '1 1 40%', minWidth: 0 }}
          >
            {t(`history.period.${preset}`)}
          </Button>
        ))}
      </Flex>
      <DatePicker.RangePicker
        value={[dayjs(period.from), dayjs(period.to)]}
        onChange={(value) => {
          const [from, to] = value ?? []
          if (from && to) onChange({ from: from.format(ISO_DAY), to: to.format(ISO_DAY) })
        }}
        disabledDate={(value) => value.format(ISO_DAY) > today}
        allowClear={false}
        inputReadOnly
        aria-label={t('history.period.custom')}
        style={{ width: '100%' }}
      />
    </Flex>
  )
}
